
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3444_19603)","fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M6.523 4.967A8.487 8.487 0 003.814 8.99a5.705 5.705 0 00-3.027 2.476 5.625 5.625 0 00-.705 3.827 5.656 5.656 0 001.951 3.375A5.747 5.747 0 005.72 20h13.72a4.611 4.611 0 001.76-.355L6.523 4.967zm16.785 12.896a4.505 4.505 0 00-.097-4.945 4.575 4.575 0 00-2.639-1.844 8.453 8.453 0 00-1.618-4.559 8.565 8.565 0 00-3.864-2.947 8.645 8.645 0 00-6.101-.024l14.319 14.32z","fill":"#0A0A0A","fill-opacity":".3"}}),_c('path',{attrs:{"d":"M1.384 1.384a1.313 1.313 0 011.857 0L21.616 19.76a1.313 1.313 0 01-1.857 1.857L1.384 3.24a1.313 1.313 0 010-1.857z","fill":"#FF4954"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3444_19603"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    